import get from 'lodash/get'
import unset from 'lodash/unset'

import MigrationShouldRun from 'api/migrate/MigrationShouldRun'
import UpdateVersion from 'api/migrate/UpdateVersion'

/**
 *
 * Upgrade notes:
 *
 * - Remove `search.default` from config
 *
 * @param {Object} config
 */

export default function (config) {
  const MIGRATION_TO_VERSION = 6

  if (MigrationShouldRun(config, MIGRATION_TO_VERSION)) {
    // Run migration scripts here...
    const layers = get(config, 'layers', [])
    for (const layer of layers) {
      unset(layer, 'search.default')
    }
    UpdateVersion(config, MIGRATION_TO_VERSION)
  }
  return config
}
